import Vue from 'vue';
import Router from 'vue-router';
//登录
import Login from '@/components/core/Login.vue';

//前台
import Main from '@/views/frontDesk/Main.vue';
import CompanyProfile from '@/views/frontDesk/CompanyProfile.vue';
import News from '@/views/frontDesk/News.vue';
import NewContent from '@/views/frontDesk/NewContent.vue';
import Product from '@/views/frontDesk/Product.vue';
import ProductContent from '@/views/frontDesk/ProductContent.vue';

//后台
import StaffInfo from '@/views/backStage/StaffInfo.vue';
import NewsList from '@/views/backStage/NewsList.vue';
import ProductList from '@/views/backStage/ProductList.vue';
import NewContentByAuthor from '@/views/backStage/NewContentByAuthor.vue';
import PreviewNews from '@/views/backStage/PreviewNews.vue';
import PreviewProduct from '@/views/backStage/PreviewProduct.vue';
import ProductType from '@/views/backStage/ProductType.vue';
import ProductContentByAuthor from '@/views/backStage/ProductContentByAuthor.vue';
import ViewedList from '@/views/backStage/ViewedList.vue';
import ViewedCount from '@/views/backStage/ViewedCount.vue';

Vue.use(Router);


//获取原型对象上的push函数
const originalPush = Router.prototype.push
//修改原型对象中的push方法
Router.prototype.push = function push(location) {
   return originalPush.call(this, location).catch(err => err)
}


export default new Router({
  routes: [
    //登录
    {
      path: '/Login',
      name: 'Login',
      component: Login,
      meta: {
        //false时表示为前台界面，true时表示为后台界面
        allowAnonymous: false
      }
    },
    //前台
    { 
      path: '/', 
      redirect: '/Main'
      ,name: 'Main',
      component: Main,
      meta: {
        //false时表示为前台界面，true时表示为后台界面
        allowAnonymous: false
      } 
    },
    {
      path: '/Main',
      name: 'Main',
      component: Main,
      meta: {
        allowAnonymous: false
      }
    },
    {
      path: '/CompanyProfile',
      name: 'CompanyProfile',
      component: CompanyProfile,
      meta: {
        allowAnonymous: false
      }
    },
    {
      path: '/News',
      name: 'News',
      component: News,
      meta: {
        allowAnonymous: false,
        pageName: "新闻动态",
        breadcrumb: [{
            name: '主页',
            href: 'Main'
          },
          {
            name: '新闻动态'
          }
        ]
      }
    },
    {
      path: '/NewContent',
      name: 'NewContent',
      component: NewContent,
      meta: {
        pageName: "新闻详情",
        breadcrumb: [{
            name: '主页',
            href: 'Main'
          },
          {
            name: '新闻动态',
            href: 'News'
          },
          {
            name: '新闻详情'
          }
        ]
      }
    },
    {
      path: '/ProductContent',
      name: 'ProductContent',
      component: ProductContent,
      meta: {
        pageName: "产品详情",
        breadcrumb: [{
            name: '主页',
            href: 'Main'
          },
          {
            name: '产品介绍',
            href: 'Product'
          },
          {
            name: '产品详情'
          }
        ]
      }
    },
    {
      path: '/Product',
      name: 'Product',
      component: Product,
      meta: {
        allowAnonymous: false,
        pageName: "产品介绍",
        breadcrumb: [{
            name: '主页',
            href: 'Main'
          },
          {
            name: '产品介绍'
          }
        ]
      }
    },

    //后台
    {
      path: '/StaffInfo',
      name: 'StaffInfo',
      component: StaffInfo,
      meta: {
        allowAnonymous: true
      }
    },
    {
      path: '/NewsList',
      name: 'NewsList',
      component: NewsList,
      meta: {
        allowAnonymous: true
      }
    },
    {
      path: '/ProductType',
      name: 'ProductType',
      component: ProductType,
      meta: {
        allowAnonymous: true
      }
    },
    {
      path: '/ProductList',
      name: 'ProductList',
      component: ProductList,
      meta: {
        allowAnonymous: true
      }
    },
    {
      path: '/NewContentByAuthor',
      name: 'NewContentByAuthor',
      component: NewContentByAuthor,
      meta: {
        pageName: "添加/修改新闻",
        allowAnonymous: false
      }
    },
    {
      path: '/PreviewNews',
      name: 'PreviewNews',
      component: PreviewNews,
      meta: {
        pageName: "新闻预览",
        allowAnonymous: false
      }
    },
    {
      path: '/ProductContentByAuthor',
      name: 'ProductContentByAuthor',
      component: ProductContentByAuthor,
      meta: {
        pageName: "添加/修改产品",
        allowAnonymous: false
      }
    },
    {
      path: '/PreviewProduct',
      name: 'PreviewProduct',
      component: PreviewProduct,
      meta: {
        pageName: "产品预览",
        allowAnonymous: false
      }
    },
    {
      path: '/ViewedList',
      name: 'ViewedList',
      component: ViewedList,
      meta: {
        allowAnonymous: true
      }
    },
    {
      path: '/ViewedCount',
      name: 'ViewedCount',
      component: ViewedCount,
      meta: {
        allowAnonymous: true
      }
    },
  ]
});